import { connect } from 'react-redux';
import AnnualBudgets from './components/AnnualBudgets';

const mapStateToProps = (state) => ({
  agencyId: state.auth.profile.extend.agency.id
});

export default connect(mapStateToProps)(AnnualBudgets);
